export function debounce(func, delay = 300) {
	let timerId;

	return function cb(...args) {
		const context = this;

		clearTimeout(timerId);

		timerId = setTimeout(() => {
			func.apply(context, args);
		}, delay);
	};
}
